/*
 * @Description:
 * @Autor: Dai YueLin
 * @Date: 2022-07-13 12:31:51
 * @LastEditors: Dai YueLin
 * @LastEditTime: 2022-09-02 10:29:20
 */
import { createApp, watchEffect } from 'vue';
import ECharts from 'vue-echarts';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import {
  BarChart,
  PieChart,
  SunburstChart,
  GraphChart,
  LinesChart,
  SankeyChart,
  HeatmapChart,
  TreemapChart,
  LineChart,
} from 'echarts/charts';
import {
  GridComponent,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  ToolboxComponent,
  DataZoomComponent,
  VisualMapComponent,
} from 'echarts/components';
import DompurifyHtml from 'vue-dompurify-html';

import { setupDirectives } from '@/plugin/directives';
import { customComponents } from '@/plugin/customComponents';
import { setupNaive } from '@/plugin/naive';
import store from './store';
import router from './router';
import App from './App.vue';
import Loki from './utils/tracking';

import './permission';
import './styles/index.scss';
import '@/utils/flexible';
import 'virtual:svg-icons-register';
import '@/utils/jsErrorReload';
use([
  CanvasRenderer,
  BarChart,
  TooltipComponent,
  GridComponent,
  TitleComponent,
  LegendComponent,
  PieChart,
  SunburstChart,
  ToolboxComponent,
  DataZoomComponent,
  VisualMapComponent,
  GraphChart,
  LinesChart,
  SankeyChart,
  HeatmapChart,
  TreemapChart,
  LineChart,
]);

const app = createApp(App);

//全局挂在loading
app.use(store);
app.use(router);
app.use(DompurifyHtml);
app.use(Loki);
setupNaive(app);
setupDirectives(app);
customComponents(app);

app.config.globalProperties.$load = '1';

app.component('VChart', ECharts);

app.mount('#app');

watchEffect(() => {
  // Listen for changes in login information
  const userInfo = store.state.user.userInfo;

  const userId = `${userInfo?.name}(${userInfo?.account})`;
  const isDev = !!import.meta.env.DEV;
  if (userInfo && !isDev) {
    const config = {
      // Refer to the "User ID format" below
      userId, // STRING
      router, // Pass in a router object
    };

    // Initialize web analyzer
    if (window.analyzerImporter) {
      console.log('🚀 ~ analyzerImporter:', window.analyzerImporter);
      window.analyzerImporter.getAnalyzerVue(app, import.meta.env.MODE === 'production' ? 684 : 310, config);
    }
  }
});
